import {getValidSelection} from './../utils';

export const KEY = 'remove_row';

export default function removeRowItem() {
  return {
    key: KEY,
    name: 'Remove row',

    callback(key, selection) {
      let amount = selection.end.row - selection.start.row + 1;

      this.alter('remove_row', selection.start.row, amount, 'ContextMenu.removeRow');
    },
    disabled() {
      const selected = getValidSelection(this);
      const totalRows = this.countRows();

      return !selected || this.selection.selectedHeader.cols || this.selection.selectedHeader.corner || !totalRows;
    },
    hidden() {
      return !this.getSettings().allowRemoveRow;
    }
  };
}



// WEBPACK FOOTER //
// src/plugins/contextMenu/predefinedItems/removeRow.js